import React from "react";
import { getNewsData, getNewsFilterData } from "../../services/TradingMallService";
import type { INewsItem } from "../../interfaces/News.interface";
import type { INewsFilterData } from "../../interfaces/NewsFilter.interface";
import type { NewsAEMContent } from "../../interfaces/NewsAEM.interface";
import StockNewsClient from "./StockNewsClient";

interface NewsProps {
  content: NewsAEMContent | null;
}

/**
 * Server component wrapper for `/investments/news`.
 * Fetches initial data on the server for SSR/SEO and passes it to the client renderer.
 */
const News = async ({ content }: NewsProps) => {
  const [filterOptions, trending, other] = await Promise.all([
    getNewsFilterData().catch(() => null as INewsFilterData | null),
    getNewsData({
      newsType: "trending",
      filters: [],
      page: 1,
      limit: 10,
    }).catch(() => [] as INewsItem[]),
    getNewsData({
      newsType: "other",
      filters: [],
      page: 1,
      limit: 5,
    }).catch(() => [] as INewsItem[]),
  ]);

  return (
    <StockNewsClient
      filterOptions={filterOptions}
      aemContent={content}
      initialTrendingNews={trending}
      initialOtherNews={other}
      initialWatchlistNews={[]}
      initialPortfolioNews={[]}
    />
  );
};

export default News;